import styled from "styled-components";

export const CardsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  justify-content: center;
  gap: 10px;
  max-width: 1100px;
  padding: 0px 20px;
`;
